import { render, staticRenderFns } from "./modalRelatorioExtrair.vue?vue&type=template&id=febb3a48&scoped=true&"
import script from "./modalRelatorioExtrair.vue?vue&type=script&lang=js&"
export * from "./modalRelatorioExtrair.vue?vue&type=script&lang=js&"
import style0 from "./modalRelatorioExtrair.vue?vue&type=style&index=0&id=febb3a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febb3a48",
  null
  
)

export default component.exports